export default {
  api_r_open_surveyUserAccessCode_checkCode: {
    path: 'survey-user-access-code/check-code/',
  },
  api_r_open_surveyUserAccessCode_signup: {
    path: 'survey-user-access-code/signup/',
  },
};
